module.exports = __webpack_public_path__ + "img/phone-contact.297c7a22.svg";